export default __webpack_public_path__ + "static/banner-media-release-oct15-9caf2c936a5a159f7ef87e54e546a373.jpg";